import { render, staticRenderFns } from "./BadgesExplanation.vue?vue&type=template&id=97f9add2&"
import script from "./BadgesExplanation.vue?vue&type=script&lang=js&"
export * from "./BadgesExplanation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports